import { PersonType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { PrivateInformationTableRow } from './components';
import { privateInformationRows } from './data';

type PrivateInformationTablePropsType = {
  personDetails: PersonType;
};

export const PrivateInformationTable: React.FC<
  PrivateInformationTablePropsType
> = ({ personDetails }) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {privateInformationRows.map((row) => (
          <PrivateInformationTableRow
            key={row.label}
            personDetails={personDetails}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
